(function () {
  'use strict';

  angular.module('app').component('billDetail', billDetail());

  function billDetail() {
    return {
      bindings: {
        item: '<',
        mode: '<',
        showActionsFromModal: '<',
        onBillSaved: '&',
        onBillCanceled: '&',
      },
      controller: BillDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bills/bill-detail/bill-detail.component.html',
    };
  }

  BillDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'SessionService',
    'AbilityService',
    'moment',
    'BillService',
    'ProviderService',
    'BookingService',
    'MeasurementUnitService',
    'DocumentTypeService',
    'TaxService',
    'ProductService',
    'ExchangeRateService',
    'ConfirmXmlModalService',
    'DocumentService',

    // Angular downgraded service
    'companyService',
    'currencyService',
  ];

  function BillDetailComponent(
    config,
    UtilService,
    SessionService,
    AbilityService,
    moment,
    BillService,
    ProviderService,
    BookingService,
    MeasurementUnitService,
    DocumentTypeService,
    TaxService,
    ProductService,
    ExchangeRateService,
    ConfirmXmlModalService,
    DocumentService,

    // Angular downgraded service
    companyService,
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_bill_accountadmin'),
      canUpdate: AbilityService.can('update_bill_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.statusDraft = 'draft';
    vm.statusPaid = 'paid';
    vm.statusAccepted = 'accepted';
    vm.statusSent = 'sent';

    // private properties
    // -----------------------
    let company = SessionService.getSelectedAccountCompany();

    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled;

      if (vm.item.id) {
        // view - edit
        if (!vm.item.user_id) {
          vm.item.user_id = SessionService.currentUser().id;
        }

        vm.isElectronicDocument = vm.item.document_type.numbering_type === 'electronic';

        setItemOptions(vm.item, vm.mode);

        // vm.documentDate = moment(vm.item.date);
        vm.documentDate = vm.UtilService.startOfDayFormat(vm.item.date); // yyyy-mm-ddT06:00:00.000Z
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          type: '08', // electronic bill TODO: What about other countries
          date: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
          due_date: '',
          subtotal_services_taxable: 0,
          subtotal_services_exempt: 0,
          subtotal_services_exonerable: 0,
          subtotal_goods_taxable: 0,
          subtotal_goods_exempt: 0,
          subtotal_goods_exonerable: 0,
          total_taxable: 0,
          total_exempt: 0,
          total_exonerable: 0,
          total_sale: 0,
          total_discount: 0,
          total_net_sale: 0,
          total_taxes: 0,
          total_exonerations: 0,
          total_net_taxes: 0,
          grand_total: 0,
          bill_products: [],
          bookings: [],
          booking_ids: [],
          company_id: company.id,
          user_id: SessionService.currentUser().id,

          // payment_method_codes: [],
        };

        vm.addBillProduct();

        vm.sendBillToProvider = false;

        // Initializers
        getDocumentTypes();

        vm.documentDate = moment();
      }

      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------
    // Atv functions
    vm.sendDocumentToAtv = function (item) {
      vm.loadingDocument = true;
      DocumentService.sendDocumentToAtv(vm.item, 'bills').then(function (data) {
        if (data) {
          vm.item.atv_status = data.atv_status;
        }

        vm.loadingDocument = false;
      });
    };

    vm.resendDocumentToAtv = function () {
      vm.loadingDocument = true;
      DocumentService.resendDocumentToAtv(vm.item, 'bills').then(function (data) {
        if (data) {
          vm.item.atv_status = data.atv_status || vm.item.atv_status; // Important if no atv status sent
        }

        vm.loadingDocument = false;
      });
    };

    vm.downloadBillPdf = function () {
      BillService.downloadBillPdf(vm.item, userLanguageCode);
    };

    vm.openConfirmXml = function () {
      ConfirmXmlModalService.openConfirmXmlDetail(vm.item.confirm_xml_id);
    };

    vm.isInvalidHeader = function () {
      if (vm.viewMode) return false;

      if (
        vm.sendingForm ||
        !(
          vm.item.provider_id &&
          vm.item.currency_id &&
          vm.item.purchase_condition_code &&
          vm.item.document_type_id &&
          vm.item.user_id &&
          vm.item.date
        ) ||
        (vm.purchaseCondition &&
          vm.purchaseCondition.value === 'credit' &&
          vm.item.credit_payment_days === undefined) ||
        (vm.purchaseCondition &&
          vm.purchaseCondition.value === 'cash' &&
          vm.item.status !== vm.statusDraft &&
          !vm.paymentProvider.payment_method_code) ||
        (vm.createMode &&
          vm.documentType &&
          vm.documentType.numbering_type === 'manual' &&
          !vm.item.bill_number)
      ) {
        return true;
      }

      // && !vm.item.payment_method_code

      return false;
    };

    vm.selectDocumentType = function (documentType) {
      if (documentType.id === vm.lastDocumentTypeId) return;

      vm.documentType = documentType;
      vm.lastDocumentTypeId = documentType.id;

      setPaymentDatePicker(vm.documentType);
    };

    vm.onProviderSelected = function (provider) {
      let selectProviderCallback = function () {
        vm.lastProviderId = provider.id;
        vm.item.provider_id = provider.id;
        vm.item.provider = provider;

        vm.item.currency_id = provider.currency_id
          ? provider.currency_id
          : vm.companyBaseCurrencyId;
        let currency = vm.currenciesPerCompany.find((item) => item.id === vm.item.currency_id); // provider.currency_id

        vm.selectCurrency(currency, true);

        vm.item.purchase_condition_code = null;

        // if (vm.item.payment_method_code){
        //     vm.item.payment_method_code = null;
        // }

        vm.item.credit_payment_days = null;
        vm.item.due_date = null;

        let providerPurchaseCondition;

        if (provider.credit_enabled) {
          // Provider has credit enabled
          vm.providerPurchaseConditions = vm.company.sale_conditions;
          providerPurchaseCondition = vm.providerPurchaseConditions.find(
            (item) => item.value === 'credit'
          );
        } else {
          let purchaseConditions = angular.copy(vm.company.sale_conditions);
          vm.providerPurchaseConditions = vm.UtilService.removeItemFromArray(
            purchaseConditions,
            'value',
            'credit'
          );
          providerPurchaseCondition = vm.providerPurchaseConditions.find(
            (item) => item.value === 'cash'
          );
        }

        vm.item.purchase_condition_code = providerPurchaseCondition.code;

        vm.selectPurchaseCondition(providerPurchaseCondition);
      };

      // Delete bill products for draft bill if change provider, when the bill has products
      if (
        vm.item.status === vm.statusDraft &&
        vm.item.bill_products.length > 0 &&
        provider.id !== vm.lastProviderId
      ) {
        let successCallback = function () {
          vm.item.bill_products = [];

          selectProviderCallback();

          return;
        };

        let cancelCallback = function () {
          // Just to keep current provider
          vm.item.provider_id = vm.lastProviderId;
        };

        let modalParams = {
          title: 'CHANGE_PROVIDER_FOR_CURRENT_BILL',
          body: 'CHANGE_PROVIDER_FOR_CURRENT_BILL_WARNING',
        };

        vm.UtilService.warningMsg(modalParams, successCallback, cancelCallback);
      } else {
        // In case the user change the provider
        if (vm.lastProviderId && provider.id !== vm.lastProviderI) {
          vm.item.bill_products = [];

          vm.addBillProduct();
        }

        selectProviderCallback();
      }
    };

    // When provider is empty
    vm.onProviderValidated = function (provider) {
      vm.item.provider = provider;

      if (!vm.item.provider && vm.item.provider_id) {
        resetProviderInput();
      }
    };

    vm.onProviderCleared = function (clearObj) {
      if (clearObj) {
        vm.item.provider = null;
      }

      resetProviderInput();
    };

    vm.selectActivityCode = function (activityCode) {
      if (vm.activityCode && vm.activityCode.code === activityCode.code) return;

      vm.activityCode = activityCode;
    };

    /*vm.convertAmountToBaseAccountingCurrency = function(amount) {
            if(!vm.item.exchange_rate_value){
                return 0;
            }
            return vm.UtilService.roundNum(amount * vm.item.exchange_rate_value);
        };
        */

    vm.selectCurrency = function (currency, setCurrency) {
      if (currency.id === vm.lastCurrencyId && !setCurrency) return;

      vm.documentDateExchangeRate = getDocumentDateExchangeRate(currency.id);

      vm.item.exchange_rate_value = vm.documentDateExchangeRate.value;
      vm.item.base_currency_symbol = vm.currenciesPerCompany.find(
        (x) => x.id === vm.companyBaseCurrencyId
      ).symbol;

      let selectCurrenyCallback = () => {
        vm.item.currency = currency;
        vm.lastCurrencyId = currency.id;
        vm.lastCurrency = currency;
      };

      if (setCurrency) {
        selectCurrenyCallback();
        return;
      }

      if (!vm.viewMode) {
        if (vm.item.bill_products.length > 0) {
          if (vm.editMode) {
            vm.lastCurrencyId = vm.item.currency.id;
          }

          convertBillProductsCostAndPrices(currency, vm.lastCurrencyId); // TODO: check if needed ????? - edit only ?
        }

        selectCurrenyCallback();
      }
    };

    vm.selectPurchaseCondition = function (purchaseCondition) {
      // Same open condition selected
      if (vm.purchaseCondition === purchaseCondition) return;

      vm.purchaseCondition = purchaseCondition;
      vm.item.due_date = vm.item.date;
      vm.item.credit_payment_days = null;

      vm.paymentProvider = {
        payment_method_code: null,
        payment_method_id: null,
      };

      if (purchaseCondition.value === 'credit') {
        let creditPaymentTerm = vm.company.credit_payment_terms.find((item) => {
          return item.id === vm.item.provider.default_credit_payment_term_id;
        });

        /*if (vm.item.provider){
                    creditPaymentTerm = vm.company.credit_payment_terms.find((item) => item.id === vm.item.provider.default_credit_payment_term_id);
                }*/

        if (creditPaymentTerm) {
          vm.item.credit_payment_days = creditPaymentTerm.days;

          vm.selectCreditPaymentTerm(creditPaymentTerm.days);
        }

        // vm.item.payment_method_code = '01'; // required
        vm.paymentProvider.payment_method_code = '01'; // required for atv ?
      }
    };

    vm.selectPaymentMethod = function (paymentMethod) {
      vm.paymentProvider.paymentMethod = paymentMethod;

      vm.receivedPayment.payment_method_id = paymentMethod.id;
    };

    vm.selectCreditPaymentTerm = function (creditPaymentTermDays) {
      let dueDate = angular.copy(vm.item.date); // Important
      vm.item.due_date = moment(dueDate).add(creditPaymentTermDays, 'days');
    };

    vm.openProviderInfoModal = function (provider) {
      ProviderService.openProviderInfoModal(provider);
    };

    vm.openProviderFastCreate = function () {
      let successCallback = function (provider) {
        vm.onProviderSelected(provider);
      };

      ProviderService.openProviderFastCreate({}, successCallback);
    };

    vm.openRelatedTransactions = function () {
      BillService.openRelatedTransactions(vm.item, vm.item.provider);
    };

    vm.addBillProduct = function () {
      vm.item.bill_products.push({
        quantity: 1,
        // unit_cost: 0,
        total_amount: 0,
        discount_percentage: 0,
        discount_amount: 0,
        subtotal_cost: 0,

        tax_percentage: 0,
        tax_amount: 0,
        tax_exoneration_percentage: 0,
        tax_exoneration_amount: 0,
        net_tax_percentage: 0,
        net_tax_amount: 0,
        total_cost: 0,
      });

      calculateBillTotals();
    };

    vm.removeBillProduct = function (index) {
      vm.item.bill_products.splice(index, 1);
      // products = vm.item.bill_products;

      calculateBillTotals();
    };

    vm.searchProduct = function (billProduct, value) {
      billProduct.product_id = null;

      return ProductService.searchProducts({ value: value, skip_check_role: true }).then(function (
        data
      ) {
        if (data.length === 0) {
          resetProductFilter(billProduct);
        }

        return data;
      });
    };

    // When product is empty
    vm.checkSearchProduct = function (billProduct) {
      if (!billProduct.product && billProduct.product_id) {
        resetProductFilter(billProduct);
      }
    };

    vm.selectProduct = function (billProduct, product) {
      billProduct.product_id = product.id;
      billProduct.product_code = product.code;
      billProduct.product_cabys_code = product.cabys_code;
      billProduct.product_name = product.name;
      billProduct.product_type = product.type;

      billProduct.measurement_unit_id =
        product.measurement_unit_id || product.product_category.measurement_unit_id;
      billProduct.measurement_units = MeasurementUnitService.setMeasurementUnitsByProductType(
        vm.company.measurement_units,
        billProduct.product_type
      );

      let measurementUnit = billProduct.measurement_units.find(
        (item) => item.id === billProduct.measurement_unit_id
      );

      vm.selectMeasurementUnit(billProduct, measurementUnit);

      getTaxesPerProduct(billProduct, product);

      vm.calculateBillProductTotalCost(billProduct);
    };

    vm.selectMeasurementUnit = function (billProduct, measurementUnit) {
      if (!measurementUnit) return;

      billProduct.measurement_unit = measurementUnit;
      billProduct.measurement_unit_symbol = measurementUnit.symbol;
    };

    vm.changeBillProductQuantity = function (billProduct) {
      let quantityBooked = 0;
      let quantityBilled = 0;

      if (!billProduct.id) {
        // Create
        quantityBooked = billProduct.quantity_booked;
        quantityBilled = billProduct.quantity_billed;
      } else {
        // Edit
        if (billProduct.booking_item_id) {
          if (billProduct.booking_item_service_item_id) {
            quantityBooked =
              billProduct.booking_item_service_item.service_item.cost_type === 'per_person'
                ? billProduct.booking_item_service_item.adults +
                  billProduct.booking_item_service_item.children +
                  billProduct.booking_item_service_item.infants +
                  billProduct.booking_item_service_item.seniors
                : 1;
            quantityBilled = billProduct.booking_item_service_item.quantity_billed;
          } else {
            quantityBooked =
              billProduct.booking_item.adults +
              billProduct.booking_item.children +
              billProduct.booking_item.infants +
              billProduct.booking_item.seniors;
            quantityBilled = billProduct.booking_item.quantity_billed;
          }

          billProduct.originalQuantity = quantityBooked;
        }
      }

      if (billProduct.booking_item_id && billProduct.quantity > quantityBooked - quantityBilled) {
        let successCallback = function () {
          vm.calculateBillProductTotalCost(billProduct);

          return;
        };

        let cancelCallback = function () {
          billProduct.quantity = billProduct.originalQuantity;
        };

        let modalParams = {
          body: 'QUANTITY_PURCHASED_IS_HIGHER_THAN_BOOKED_WARNING',
        };

        vm.UtilService.warningMsg(modalParams, successCallback, cancelCallback);
      } else {
        vm.calculateBillProductTotalCost(billProduct);
      }
    };

    vm.editBillProductRemarks = function (billProduct) {
      vm.billProduct = billProduct;
    };

    vm.calculateBillProductTotalCost = function (billProduct) {
      billProduct.quantity = billProduct.quantity || 1;

      billProduct.tax_percentage = TaxService.getProductTaxesTotalPercentage(
        billProduct.productTaxes
      );
      billProduct.tax_exoneration_percentage = TaxService.getProductTaxesTotalExonerationPercentage(
        billProduct.productTaxes
      );
      billProduct.net_tax_percentage =
        billProduct.tax_percentage - billProduct.tax_exoneration_percentage;

      let unitCost = billProduct.unit_cost; // || 0
      let discountPercentage = billProduct.discount_percentage || 0;

      let totalAmount = billProduct.quantity * unitCost;
      let discountAmount = totalAmount * (discountPercentage / 100);
      let subtotalCost = totalAmount - discountAmount;

      billProduct.transaction_taxes = TaxService.setProductTaxesAmounts(
        subtotalCost,
        billProduct.productTaxes
      );

      let taxAmount = TaxService.getProductTaxesTotalAmount(billProduct.transaction_taxes);
      let taxExonerationAmount = TaxService.getProductTaxesTotalExonerationAmount(
        billProduct.transaction_taxes
      );
      let netTaxAmount = taxAmount - taxExonerationAmount;

      if (unitCost) {
        billProduct.unit_cost = vm.UtilService.roundNum(unitCost);
      }

      billProduct.total_amount = vm.UtilService.roundNum(totalAmount);
      billProduct.discount_percentage = discountPercentage;
      billProduct.discount_amount = vm.UtilService.roundNum(discountAmount);
      billProduct.subtotal_cost = vm.UtilService.roundNum(subtotalCost);

      billProduct.tax_amount = vm.UtilService.roundNum(taxAmount);
      billProduct.tax_exoneration_amount = vm.UtilService.roundNum(taxExonerationAmount);
      billProduct.net_tax_amount = vm.UtilService.roundNum(netTaxAmount);

      billProduct.total_cost = vm.UtilService.roundNum(subtotalCost + netTaxAmount);

      calculateBillTotals();
    };

    vm.openDocumentProductTaxesExonerations = function (billProduct) {
      if (vm.viewMode || billProduct.tax_amount === 0) return;

      const successCallBack = function (documentProductObj) {
        // console.log(documentProductObj);
        vm.calculateBillProductTotalCost(documentProductObj);
      };

      ProductService.openDocumentProductTaxesExonerations(
        billProduct,
        vm.item.currency,
        'purchases',
        successCallBack
      );
    };

    vm.editBill = function () {
      vm.editMode = true;
      vm.viewMode = false;

      vm.originalItem = angular.copy(vm.item); // store server data

      // if(vm.item.credit_payment_days){
      //     vm.showCreditOptions = true;
      // }

      getDocumentTypes();

      if (vm.companyCurrencyIds) {
        getCurrencies(vm.companyCurrencyIds);
      }
    };

    /*vm.cancelEdit = function() {
            vm.item = vm.originalItem;

            setItemOptions(vm.item);
            setBillProducts();

            // setCompanyActivityCode(vm.company);
        };*/

    vm.saveBill = function (isFormValid, status) {
      vm.formErrors = false;

      if (!isFormValid && status !== vm.statusDraft) {
        vm.serverErrors = [];
        vm.formErrors = true;
        vm.UtilService.scrollToTop();

        return;
      }

      if (!vm.allProductsCabysCodeSet) return;

      let createBill = function () {
        // if (vm.item.payment_method_code) {
        //     vm.item.payment_method_codes.push(vm.item.payment_method_code);
        // }

        if (vm.paymentProvider && vm.paymentProvider.payment_method_code) {
          vm.item.payment_method_code = vm.paymentProvider.payment_method_code;
          vm.item.payment_method_id = vm.paymentProvider.payment_method_id;
          vm.item.payment_method_codes = [vm.item.payment_method_code];
        } else {
          vm.item.payment_method_code = null;
          vm.item.payment_method_id = null;
          vm.item.payment_method_codes = [];
        }

        vm.item.status = setBillStatus(vm.item, status);

        let bill = setBillParams();

        // console.log(bill); return;

        vm.sendingForm = true;
        BillService.saveBill(bill, vm.paymentProvider).then(function (data) {
          let status = data.status;
          let response = data.response;

          if (status) {
            if (!vm.editMode) {
              // create
              vm.onBillSaved({ item: response });
            } else if (vm.editMode) {
              vm.item = response; // reload item
              setItemOptions(response);

              setCompanyActivityCode(vm.company);

              vm.purchaseCondition = vm.company.sale_conditions.find(
                (item) => item.code === response.purchase_condition_code
              );

              // if (response.payment_method_code) {
              //     vm.paymentMethod = vm.company.payment_methods.find((item) => item.code === response.payment_method_code);
              // }

              vm.user = vm.company.users.find((user) => user.id === response.user_id);

              if (response.credit_payment_days >= 0) {
                vm.creditPaymentTerm = vm.company.credit_payment_terms.find(
                  (item) => item.days === response.credit_payment_days
                );
              }

              setBillProducts();
            }
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.UtilService.scrollToTop();

          vm.sendingForm = false;
        });
      };

      if (status !== vm.statusDraft && vm.sendBillToProvider) {
        let successCallBack = function (email) {
          vm.item.provider_email_receipt = email;

          createBill();
        };

        BillService.openSendBillToProvider(vm.item.provider.email, successCallBack);
      } else {
        vm.item.provider_email_receipt = vm.item.provider.email;

        createBill();
      }
    };

    vm.cancel = function () {
      /*if (vm.editMode) {
                vm.cancelEdit();
                return;
            }*/

      vm.onBillCanceled();
    };

    vm.showBillProductRelatedBooking = function (billProduct) {
      vm.relatedBookingItem = {
        booking_number: billProduct.booking_number,
        quantity: billProduct.quantity,
      };

      if (billProduct.booking_item_service_item_id) {
        vm.relatedBookingItem.reference_number =
          billProduct.booking_item_service_item.booking_item_service_item_number;
        vm.relatedBookingItem.provider = billProduct.booking_item_service_item.provider;
        vm.relatedBookingItem.quantity_billed =
          billProduct.booking_item_service_item.quantity_billed;
      } else {
        vm.relatedBookingItem.reference_number = billProduct.booking_item.booking_item_number;
        vm.relatedBookingItem.provider = billProduct.booking_item.provider;
        vm.relatedBookingItem.quantity_billed = billProduct.booking_item.quantity_billed;
      }
    };

    vm.openSearchRelatedBookings = function (billProduct, index) {
      let successCallback = function (booking) {
        vm.item.bookings.push(booking);
        vm.item.booking_ids.push(booking.id);

        vm.item.bill_products.splice(index, 1);

        addProductsFromBookingToBill(booking);
      };

      BookingService.openSearchRelatedBookings(
        vm.item,
        billProduct,
        vm.item.provider,
        successCallback
      );
    };

    /*vm.openServiceItemFastCreate = function() {
            let successCallback = function (provider) {
                selectProvider(provider);
            };

            ServiceItemService.openServiceItemFastCreate({}, successCallback);
        };*/

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editBill();
      }

      if (item.is_from_booking && item.bill_products.length > 0 && item.bookings.length > 0) {
        setProductsFromBooking();
      }

      if (item.payment_providers.length > 0) {
        vm.paymentProvider = item.payment_providers[0];
      }

      // products = vm.item.bill_products;
    }

    function setProductsFromBooking() {
      vm.item.bill_products.forEach(function (product) {
        vm.item.bookings.forEach(function (booking) {
          booking.booking_items.forEach(function (bookingItem) {
            if (product.booking_item_id === bookingItem.id) {
              product.booking_number = booking.booking_number;
            }
          });
        });
      });
    }

    // Initializers
    function getCompany() {
      vm.loadingCurrenciesPerCompany = true;

      vm.loadingCompany = true;
      vm.loadingBillProducts = true; // !important

      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          vm.company = response;

          vm.company.payment_methods = vm.company.payment_methods.filter(
            (method) => method.status == true
          );

          vm.companyBaseCurrencyId = vm.company.currency_id;
          vm.companyCurrencyIds = vm.company.currency_ids;

          // Create / Edit
          if (!vm.viewMode) {
            getCurrencies(vm.companyCurrencyIds);
          }

          // View / Edit
          if (!vm.createMode) {
            setCompanyActivityCode(vm.company);

            vm.purchaseCondition = vm.company.sale_conditions.find(
              (x) => x.code === vm.item.purchase_condition_code
            );

            vm.providerPurchaseConditions = vm.company.sale_conditions;

            // Provider with credit disabled - viewMode
            if (vm.item.status === vm.statusDraft && !vm.item.provider.credit_enabled) {
              let purchaseConditions = angular.copy(vm.providerPurchaseConditions);
              vm.providerPurchaseConditions = vm.UtilService.removeItemFromArray(
                purchaseConditions,
                'value',
                'credit'
              );
            }

            if (vm.item.credit_payment_days >= 0) {
              vm.creditPaymentTerm = vm.company.credit_payment_terms.find(
                (x) => x.days === vm.item.credit_payment_days
              );
            }

            // Cash
            if (vm.item.purchase_condition_code === '01' && vm.paymentProvider) {
              vm.paymentProvider.paymentMethod = vm.company.payment_methods.find(
                (x) => x.code === vm.paymentProvider.payment_method_code
              );
            }

            /*if (vm.item.payment_method_code){
                        vm.paymentMethod = vm.company.payment_methods.find((paymentMethod) => paymentMethod.code === vm.item.payment_method_code);
                    }*/

            vm.user = vm.company.users.find((user) => user.id === vm.item.user_id);

            setBillProducts();
          } else {
            vm.item.company_activity_code = vm.company.activity_codes.find(
              (x) => x.id === vm.company.company_activity_code_id
            ).code;

            vm.loadingBillProducts = false; // !important
          }

          vm.loadingCompany = false;
        });
    }

    function setCompanyActivityCode(company) {
      if (!vm.atvCrEnabled) return;

      let activityCode = company.activity_codes.find((activityCode) => {
        return (
          activityCode.code === vm.item.company_activity_code ||
          activityCode.id === vm.item.company_activity_code_id
        );
      });

      vm.companyActivityCode = activityCode;
      vm.item.company_activity_code = activityCode.code;
    }

    function getDocumentTypes() {
      if (vm.documentTypes) return;

      let params = {
        get: 'active',
        transaction_type: 'bills',
        skip_check_role: true,
      };

      vm.loadingDocumentTypes = true;
      DocumentTypeService.getDocumentTypes(params).then(function (data) {
        vm.documentTypes = data.items;

        // Preload default document type on create
        if (vm.createMode) {
          vm.documentType = vm.documentTypes.find((documentType) => documentType.is_default); //  === true
          vm.item.document_type_id = vm.documentType.id;
        } else {
          vm.documentType = vm.documentTypes.find(
            (documentType) => documentType.id === vm.item.document_type_id
          );
        }

        vm.lastDocumentTypeId = vm.documentType.id;

        vm.isElectronicDocument = vm.documentType.numbering_type === 'electronic';

        setPaymentDatePicker(vm.documentType);

        vm.loadingDocumentTypes = false;
      });
    }

    function setPaymentDatePicker(documentType) {
      let minDate = documentType.allows_past_days ? false : moment();
      let maxDate = documentType.allows_future_days ? false : moment();

      let onChangeDate = () => {
        vm.documentDate = moment(vm.item.date);
        getDocumentDateExchangeRate(vm.item.currency_id);

        vm.selectCreditPaymentTerm(vm.item.credit_payment_days);
      };

      vm.datePickerOptions = vm.UtilService.singleDatePickerOptions({
        minDate: minDate,
        maxDate: maxDate,
        dateDisplay: vm.dateDisplay,
        onChangeDate: onChangeDate,
      });
    }

    function getCurrencies(companyCurrencyIds) {
      if (vm.currenciesPerCompany) return;

      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
        // documentDate: null,
      };

      if (!vm.createMode) {
        params.documentDate = vm.documentDate;
      }

      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currenciesPerCompany = response;

        if (vm.editMode) {
          vm.selectCurrency(vm.item.currency, true);
        }

        vm.loadingCurrenciesPerCompany = false;
      });
    }

    function resetProviderInput() {
      vm.item.provider_id = null;
      vm.item.currency_id = null;
      vm.item.purchase_condition_code = null;
      vm.item.credit_payment_days = null;
      vm.item.due_date = null;

      // if (vm.item.payment_method_code){
      //     vm.item.payment_method_code = null;
      // }

      if (vm.paymentProvider && vm.paymentProvider.payment_method_code) {
        vm.paymentProvider.payment_method_code = null;
        vm.paymentProvider.payment_method_id = null;
      }

      vm.item.bill_products = [];

      vm.addBillProduct();
    }

    function getDocumentDateExchangeRate(currencyId) {
      if (vm.item.provider_id === undefined) return;

      return ExchangeRateService.getDocumentDateExchangeRate(
        vm.currenciesPerCompany,
        vm.companyBaseCurrencyId,
        currencyId
      ); // , vm.documentDate
    }

    function resetProductFilter(billProduct) {
      billProduct.product_id = null;
      billProduct.measurement_unit_id = null;
      billProduct.quantity = 1;
      billProduct.unit_cost = ''; // 0
      billProduct.discount_percentage = 0;

      billProduct.tax_percentage = 0;
      billProduct.tax_amount = 0;
      billProduct.tax_exoneration_percentage = 0;
      billProduct.tax_exoneration_amount = 0;
      billProduct.net_tax_percentage = 0;
      billProduct.net_tax_amount = 0;
      billProduct.total_cost = 0;

      vm.calculateBillProductTotalCost(billProduct);
    }

    function getTaxesPerProduct(billProduct, product) {
      // product = billProduct.product || product;
      product = vm.editMode ? billProduct.product : product;

      let documentDate = moment(vm.item.date);

      billProduct.productTaxes = TaxService.setProductTaxes(product, documentDate).purchaseTaxes;

      // if (productTaxes) {
      //     billProduct.transaction_taxes = productTaxes;
      // }
    }

    function calculateBillTotals() {
      let subtotal_services_taxable = 0;
      let subtotal_services_exempt = 0;
      let subtotal_services_exonerable = 0;
      let subtotal_goods_taxable = 0;
      let subtotal_goods_exempt = 0;
      let subtotal_goods_exonerable = 0;

      let total_sale = 0;
      let total_discount = 0;
      let total_net_sale = 0;
      let total_taxes = 0;
      let total_tax_exonerations = 0;
      let total_net_taxes = 0;
      let grand_total = 0;

      vm.allProductsCabysCodeSet = true;

      vm.item.bill_products.forEach(function (bill_product) {
        let total_amount = bill_product.total_amount;

        // if (bill_product.tax_amount > 0) {
        if (!bill_product.is_exempt) {
          if (bill_product.measurement_unit && bill_product.measurement_unit.is_a_service) {
            if (bill_product.tax_exoneration_amount > 0) {
              subtotal_services_taxable +=
                (1 - (bill_product.tax_exoneration_percentage * 1) / bill_product.tax_percentage) *
                total_amount;
              subtotal_services_exonerable += total_amount - subtotal_services_taxable;
            } else {
              subtotal_services_taxable += total_amount;
            }
          } else {
            if (bill_product.tax_exoneration_amount > 0) {
              subtotal_goods_taxable +=
                (1 - (bill_product.tax_exoneration_percentage * 1) / bill_product.tax_percentage) *
                total_amount;
              subtotal_goods_exonerable += total_amount - subtotal_goods_taxable;
            } else {
              subtotal_goods_taxable += total_amount;
            }
          }
        } else {
          if (bill_product.measurement_unit && bill_product.measurement_unit.is_a_service) {
            subtotal_services_exempt += total_amount;
          } else {
            subtotal_goods_exempt += total_amount;
          }
        }

        total_sale += bill_product.total_amount;
        total_discount += bill_product.discount_amount;
        total_net_sale += bill_product.subtotal_cost;
        total_taxes += bill_product.tax_amount;
        total_tax_exonerations += bill_product.tax_exoneration_amount;
        total_net_taxes += bill_product.net_tax_amount;
        grand_total += bill_product.total_cost;

        if (vm.atvCrEnabled && vm.isElectronicDocument && !bill_product.product_cabys_code) {
          vm.allProductsCabysCodeSet = false;
        }
      });

      // check these values with Pablo
      let total_taxable = subtotal_services_taxable + subtotal_goods_taxable;
      let total_exempt = subtotal_services_exempt + subtotal_goods_exempt;
      let total_exonerable = subtotal_services_exonerable + subtotal_goods_exonerable;
      let total_retornable_taxes = 0;
      let total_other_charges = 0;

      vm.item.subtotal_services_taxable = vm.UtilService.roundNum(subtotal_services_taxable);
      vm.item.subtotal_services_exempt = vm.UtilService.roundNum(subtotal_services_exempt);
      vm.item.subtotal_services_exonerable = vm.UtilService.roundNum(subtotal_services_exonerable);
      vm.item.subtotal_goods_taxable = vm.UtilService.roundNum(subtotal_goods_taxable);
      vm.item.subtotal_goods_exempt = vm.UtilService.roundNum(subtotal_goods_exempt);
      vm.item.subtotal_goods_exonerable = vm.UtilService.roundNum(subtotal_goods_exonerable);

      vm.item.total_taxable = vm.UtilService.roundNum(total_taxable);
      vm.item.total_exempt = vm.UtilService.roundNum(total_exempt);
      vm.item.total_exonerable = vm.UtilService.roundNum(total_exonerable);
      vm.item.total_sale = vm.UtilService.roundNum(total_sale);
      vm.item.total_discount = vm.UtilService.roundNum(total_discount);
      vm.item.total_net_sale = vm.UtilService.roundNum(total_net_sale);

      vm.item.total_taxes = vm.UtilService.roundNum(total_taxes);
      vm.item.total_tax_exonerations = vm.UtilService.roundNum(total_tax_exonerations);
      vm.item.total_net_taxes = vm.UtilService.roundNum(total_net_taxes);
      vm.item.total_retornable_taxes = vm.UtilService.roundNum(total_retornable_taxes);
      vm.item.total_other_charges = vm.UtilService.roundNum(total_other_charges);
      vm.item.grand_total = vm.UtilService.roundNum(grand_total);

      // if (vm.purchaseCondition.value === 'credit') {
      vm.item.balance_due = vm.item.grand_total;
      // }
    }

    function convertBillProductsCostAndPrices(currency, lastCurrencyId) {
      let applyExchangeRateConversion = (amount) =>
        ExchangeRateService.applyExchangeRateConversion(
          amount,
          vm.documentDateExchangeRateForConversions
        );

      // For conversions
      vm.documentDateExchangeRateForConversions =
        ExchangeRateService.getDocumentDateExchangeRateForConversions(
          vm.currenciesPerCompany,
          vm.companyBaseCurrencyId,
          currency.id,
          lastCurrencyId
        ); // , vm.documentDate

      vm.item.subtotal_services_taxable = applyExchangeRateConversion(
        vm.item.subtotal_services_taxable
      );
      vm.item.subtotal_services_exempt = applyExchangeRateConversion(
        vm.item.subtotal_services_exempt
      );
      vm.item.subtotal_services_exonerable = applyExchangeRateConversion(
        vm.item.subtotal_services_exonerable
      );
      vm.item.subtotal_goods_taxable = applyExchangeRateConversion(vm.item.subtotal_goods_taxable);
      vm.item.subtotal_goods_exempt = applyExchangeRateConversion(vm.item.subtotal_goods_exempt);
      vm.item.subtotal_goods_exonerable = applyExchangeRateConversion(
        vm.item.subtotal_goods_exonerable
      );

      vm.item.total_taxable = applyExchangeRateConversion(vm.item.total_taxable);
      vm.item.total_exempt = applyExchangeRateConversion(vm.item.total_exempt);
      vm.item.total_exonerable = applyExchangeRateConversion(vm.item.total_exonerable);
      vm.item.total_sale = applyExchangeRateConversion(vm.item.total_sale);
      vm.item.total_discount = applyExchangeRateConversion(vm.item.total_discount);
      vm.item.total_net_sale = applyExchangeRateConversion(vm.item.total_net_sale);

      vm.item.total_taxes = applyExchangeRateConversion(vm.item.total_taxes);
      vm.item.total_tax_exonerations = applyExchangeRateConversion(vm.item.total_tax_exonerations);
      vm.item.total_net_taxes = applyExchangeRateConversion(vm.item.total_net_taxes);
      vm.item.total_retornable_taxes = applyExchangeRateConversion(vm.item.total_retornable_taxes);
      vm.item.total_other_charges = applyExchangeRateConversion(vm.item.total_other_charges);
      vm.item.grand_total = applyExchangeRateConversion(vm.item.grand_total);
      vm.item.balance_due = applyExchangeRateConversion(vm.item.balance_due);

      if (vm.item.bill_products.length > 0) {
        vm.item.bill_products.forEach(function (billItem) {
          if (billItem.unit_cost) {
            billItem.unit_cost = applyExchangeRateConversion(billItem.unit_cost);
            billItem.total_amount = applyExchangeRateConversion(billItem.total_amount);
            billItem.discount_amount = applyExchangeRateConversion(billItem.discount_amount);
            billItem.subtotal_cost = applyExchangeRateConversion(billItem.subtotal_cost);

            billItem.tax_amount = applyExchangeRateConversion(billItem.tax_amount);
            billItem.tax_exoneration_amount = applyExchangeRateConversion(
              billItem.tax_exoneration_amount
            );
            billItem.net_tax_amount = applyExchangeRateConversion(billItem.net_tax_amount);
            billItem.total_cost = applyExchangeRateConversion(billItem.total_cost);
          }
        });
      }

      // not needed as it was get in selectCurrency //
      // vm.documentDateExchangeRate = getDocumentDateExchangeRate(currency.id);
      // vm.lastCurrencyId = currency.id;
      // vm.lastCurrency   = currency;
    }

    function setBillStatus(bill, status) {
      if (status === vm.statusDraft) return status;

      if (vm.purchaseCondition.value === 'credit') {
        if (moment() >= bill.due_date) {
          return 'overdue';
        } else {
          return 'due';
        }
      }

      return status;
    }

    function setBillParams() {
      let bill = angular.copy(vm.item);

      delete bill.currency;
      delete bill.provider;
      delete bill.bookings;

      bill.bill_products.forEach(function (product) {
        delete product.$$hashKey;
        delete product.measurement_units;
        delete product.measurement_unit;
        delete product.product;
        delete product.originalQuantity;
        delete product.quantity_billed;
        delete product.quantity_booked;

        if (!product.unit_cost) {
          product.unit_cost = 0;
        }
      });

      return bill;
    }

    // Set related data to each product
    function setBillProducts() {
      vm.loadingBillProducts = false;

      if (vm.item.bill_products.length === 0) return;

      vm.allProductsCabysCodeSet = true;

      vm.item.bill_products.forEach(function (billProduct) {
        billProduct.measurement_units = MeasurementUnitService.setMeasurementUnitsByProductType(
          vm.company.measurement_units,
          billProduct.product_type
        );

        let measurementUnit = billProduct.measurement_units.find(
          (item) => item.id === billProduct.measurement_unit_id
        );

        vm.selectMeasurementUnit(billProduct, measurementUnit);

        if (vm.atvCrEnabled && vm.isElectronicDocument && !billProduct.product_cabys_code) {
          vm.allProductsCabysCodeSet = false;
        }
      });
    }

    // TODO: check this / totals
    function addProductsFromBookingToBill(booking) {
      // products.pop(); // remove last product - why?

      booking.booking_items_selected.forEach(function (bookingItem) {
        // ProductService.searchProducts({ value: bookingItem.product_name }).then(function (data) {
        // for (let index = 0; index < data.length; index++) {
        // let product = data[index];

        // if (product.id === bookingItem.product_id) {

        let params = {
          id: bookingItem.product_id,
          type: bookingItem.product_type, // bookingItem.booking_type
          skip_check_role: true,
        };

        ProductService.searchProducts(params).then(function (product) {
          // data
          let billProduct = {
            // type:                '04', // = uso interno - WHY ?? make it dynamic
            product_id: bookingItem.product_id,
            product_code: bookingItem.product_code,
            product_cabys_code: bookingItem.product_cabys_code,
            product_type: bookingItem.product_type,
            product_name: bookingItem.product_name,

            quantity: bookingItem.quantity_booked - bookingItem.quantity_billed,
            originalQuantity: bookingItem.quantity_booked - bookingItem.quantity_billed,
            unit_cost: vm.UtilService.roundNum(
              bookingItem.total_cost / bookingItem.quantity_booked
            ),
            tax_percentage: bookingItem.tax_cost_percentage,
            discount_percentage: bookingItem.discount_cost_percentage,

            booking_id: booking.id,
            booking_number: booking.booking_number,
            booking_item_id: bookingItem.id,

            quantity_booked: bookingItem.quantity_booked,
            quantity_billed: bookingItem.quantity_billed,
            product_category: product.product_category,
            measurement_unit_id: bookingItem.measurement_unit_id,

            booking_item_service_item_id: null,
            measurement_units: null,
          };

          getTaxesPerProduct(billProduct, product);

          if (bookingItem.booking_item_service_item_id) {
            billProduct.booking_item_service_item_id = bookingItem.booking_item_service_item_id;
          }

          billProduct.measurement_units = MeasurementUnitService.setMeasurementUnitsByProductType(
            vm.company.measurement_units,
            billProduct.product_type
          );

          let measurementUnit = vm.company.measurement_units.find(
            (item) => item.id === billProduct.measurement_unit_id
          );

          vm.selectMeasurementUnit(billProduct, measurementUnit);

          if (vm.item.bill_products.length === 1 && !vm.item.bill_products[0].product_name) {
            vm.item.bill_products.splice(0, 1);
          }

          vm.item.bill_products.push(billProduct);

          vm.calculateBillProductTotalCost(billProduct);

          // break;
          // }
          // }
        });
      });
    }
  }
})();
